export const common = {
	common: {
		viewProject: "View Project",
		viewOnAppStore: "View on App Store",
		viewOnGitHub: "View on GitHub",
		viewCompany: "View Company",
	},

	nav: {
		home: "Home",
		about: "About",
		projects: "Projects",
		outputs: "Outputs",
		services: "Services",
		contact: "Contact",
		privacyPolicy: "Privacy Policy",
		termsOfService: "Terms of Service",
		commercialLaw: "Commercial Law",
		disclaimer: "Disclaimer",
	},

	footer: {
		copyright: "© 2026 Kazumasa Shimomura. All Rights Reserved.",
	},

	notFound: {
		title: "404",
		description: "The page you are looking for could not be found.",
		backToHome: "Back to Home",
	},
} as const;
